import React from 'react';
import styled, { css } from 'styled-components';
import { Modal, Button } from 'fpay-ui';
import useBreakpoint from '@hooks/breakpoint';

const ButtonsContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column-reverse;
    margin: 20px 0 0;
    justify-content: space-evenly;
    ${theme.breakpoint('md')} {
      display: flex;
      flex-direction: row;
    }
  `
);

const CancelButton = styled(Button)(
  ({ theme }) => css`
    margin: 9px 0px;
    padding: 15px 14px;
    display: flex;
    justify-content: center;
    ${theme.breakpoint('md')} {
      padding: 0px 29px;
      display: flex;
      justify-content: center;
    }
  `
);

const ConfirmButton = styled(Button)(
  ({ theme }) => css`
    padding: 15px 14px;
    ${theme.breakpoint('md')} {
      width: 112px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `
);

const Container = styled.div(
  ({ theme }) => css`
    padding: 35px 24px 0;
    ${theme.breakpoint('md')} {
      margin: unset;
      padding: 35px 32px;
    }
  `
);

const Children = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.gray800};
    display: flex;
    font-family: Roboto;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    margin-bottom: 24px;
    ${theme.breakpoint('md')} {
      margin: 0;
    }
  `
);

const BlockUserModal = (props) => {
  const {
    open,
    toggleModal,
    confirmAction,
    textBody,
    textConfirm,
    testId,
    htmlIdCancelButton = 'unidentified-id',
    htmlIdConfirmButton = 'unidentified-id',
  } = props;
  const { mobile } = useBreakpoint();

  return (
    <Modal
      open={open}
      showCloseButton={false}
      fClose={toggleModal}
      width={mobile ? '312px' : '400px'}
      data-testid={`${testId}`}
    >
      <Container data-testid={`${testId}-container`}>
        <Children data-testid={`${testId}-children`}>{textBody}</Children>
        <ButtonsContainer data-testid={`${testId}-buttons-container`}>
          <CancelButton
            id={htmlIdCancelButton}
            type="link"
            onClick={toggleModal}
            data-testid={`${testId}-cancel-button`}
          >
            Cancelar
          </CancelButton>
          <ConfirmButton
            id={htmlIdConfirmButton}
            onClick={() => confirmAction()}
            data-testid={`${testId}-confirm-button`}
          >
            {textConfirm}
          </ConfirmButton>
        </ButtonsContainer>
      </Container>
    </Modal>
  );
};

export default BlockUserModal;
